/**
 * The rates a carrier quoted, and which one the merchant picked. Held apart from the shipment
 * details that were quoted on: both resolution paths of the flow end in a rate, and only one of
 * them edits an address.
 *
 * An empty answer counts as a failure. A carrier that quotes nothing has not told the merchant
 * anything they can act on inside this path, and the flow has another path to offer them.
 */
import { makeAutoObservable } from "mobx";
import { IPortalDynamicShippingOptionDto } from "../../rma-types";

class ShippingRatesStore {
    private _rates: IPortalDynamicShippingOptionDto[] = [];
    private _selectedRate: IPortalDynamicShippingOptionDto | null = null;
    private _failed = false;

    constructor() {
        makeAutoObservable(this, {}, { autoBind: true });
    }

    public get rates(): IPortalDynamicShippingOptionDto[] { return this._rates; }

    public get selectedRate(): IPortalDynamicShippingOptionDto | null { return this._selectedRate; }

    /** True when the last quote could not be used - it failed outright or came back empty. */
    public get failed(): boolean { return this._failed; }

    public setSelectedRate(rate: IPortalDynamicShippingOptionDto | null): void {
        this._selectedRate = rate;
    }

    /** The first rate is picked for the merchant: the screen must open on something to approve. */
    public apply(rates: IPortalDynamicShippingOptionDto[]): void {
        this._rates = rates;
        this._selectedRate = rates[0] ?? null;
        this._failed = rates.length === 0;
    }

    public fail(): void {
        this.reset();
        this._failed = true;
    }

    public reset(): void {
        this._rates = [];
        this._selectedRate = null;
        this._failed = false;
    }
}

export default ShippingRatesStore;
